export default {
  CASH_REGISTER_READINGS_PAYMENT_ITEM_LIST: "Liste des paiements",
  ADD_CASH_REGISTER_READING_PAYMENT_ITEM: "Ajouter un paiement",
  CASH_REGISTER_READING_PAYMENT_ITEM_ADDED: "Paiement ajouté",
  EDIT_CASH_REGISTER_READING_PAYMENT_ITEM: "Modifier le paiement",
  CASH_REGISTER_READING_PAYMENT_ITEM_UPDATED: "Paiement mis à jour",
  DELETE_THIS_CASH_REGISTER_READING_PAYMENT_ITEM: "Supprimer ce paiement ?",
  CASH_REGISTER_READING_PAYMENT_ITEM_DELETED: "Paiement supprimé",
  STARTS_AT: "Début",
  ENDS_AT: "Fin",
  CREATED_BY: "Créé par",
  UPDATED_BY: "Modifié par",
  AMOUNT: "Montant",
  TITLE: "Titre",
};
